import React, {forwardRef} from 'react';
import Button from '../../incase-domain/components/button/Button';
import Label from '../../incase-domain/components/label/Label';

export interface NumberInputProps {
    value: number;
    step?: number;
    text?: string;
    min: number;
    max?: number;
    onChange: (num: number) => void;
    disabled?: boolean;
    label?: string;
    compact?: boolean;
}

const NumberInput = forwardRef<HTMLInputElement, NumberInputProps>((props, ref) => {
    const {label, value, step = 1, text, min, onChange, disabled, max = Infinity, compact} = props;

    function sanitizeInput(e: React.ChangeEvent<HTMLInputElement>): void {
        const {value} = e.target;
        let numValue = parseFloat(value);
        if (!Number.isNaN(numValue)) {
            if (max && numValue > max) numValue = max;
            if (numValue < min) numValue = min;
            onChange(numValue);
        }
    }

    const minusDisabled = disabled || value <= min;
    const plusDisabled = disabled || value >= max;

    return (
        <div className="u-flex u-v-center u-h-between u-gap-2">
            {label && <Label>{label}</Label>}
            <div className={`c-numberInput ${disabled && 'c-numberInput--disabled'}`}>
                <Button
                    type="button"
                    variant={minusDisabled ? 'ghost' : 'soft'}
                    size="xs"
                    square
                    leading="ph:minus-bold"
                    disabled={minusDisabled}
                    onClick={
                        disabled
                            ? undefined
                            : () => {
                                  if (value > min) onChange(parseFloat((value - step).toFixed(2)));
                              }
                    }
                />
                <div className={`c-numberInput__inputValue ${compact && 'c-numberInput__inputValue--compact'}`}>
                    <input
                        ref={ref}
                        type="number"
                        min={min}
                        step={step}
                        max={max}
                        value={value}
                        style={{width: `${value.toString().length + 3}ch`}}
                        onChange={sanitizeInput}
                        onKeyDown={(e) => {
                            if (e.key === '-') e.preventDefault();
                        }}
                    />
                    <p>{text}</p>
                </div>
                <Button
                    type="button"
                    variant={plusDisabled ? 'ghost' : 'soft'}
                    size="xs"
                    square
                    leading="ph:plus-bold"
                    disabled={plusDisabled}
                    onClick={disabled ? undefined : () => onChange(parseFloat((value + step).toFixed(2)))}
                />
            </div>
        </div>
    );
});

export default NumberInput;
